// extracted by mini-css-extract-plugin
export var fb = "styles-module--fb--0f210";
export var ig = "styles-module--ig--ae8ae";
export var link = "styles-module--link--81bf2";
export var mc = "styles-module--mc--67e55";
export var sc = "styles-module--sc--f5b2c";